//Router
import { createBrowserRouter, Navigate } from "react-router-dom";
// Layout
import AdminBase from "../pages/private/base/AdminBase";
// Public
import Login from "../pages/public/Login";
import BaseLocais from "../pages/private/Locais/BaseLocais";
import { lazy, Suspense } from "react";
import LoadingCircular from "../utils/componentes/LoadingCircular";

const MinhasReservasPreview = lazy(() => import('../pages/private/MinhasReservas/MinhasReservas'));
const SolicitacoesPendentesPreview = lazy(() => import('../pages/private/Gestor/Solicitacoes/SolicitacoesPendentes'));
const TodasReservasPreview = lazy(() => import('../pages/private/Gestor/Reservas/TodasReservas'));
const BaseCalendarioPreview = lazy(() => import('../pages/private/Calendario/BaseCalendario'));

export const router = createBrowserRouter([
    {
        path: '/login',
        element: <Login />,
        children: []
    },
    {
        path: '/',
        element: <Navigate to='/login' />,
        children: []
    },
    {
        path: '*',
        element: <Navigate to='/login' />,
        children: []
    },
    {
        path: '/private/agenda',
        element: <AdminBase size="md" />,
        children: [
            {
                path: 'locais',
                element: <BaseLocais />,
                children: []
            },
            {
                path: 'calendario/:idLocal',
                element:
                    <Suspense fallback={<LoadingCircular />}>
                        <BaseCalendarioPreview />
                    </Suspense>,
                children: []
            },
        ]
    },
    {
        path: '/private/reservas',
        element: <AdminBase size="md" />,
        children: [
            {
                path: 'minhasReservas',
                element:
                    <Suspense fallback={<LoadingCircular />}>
                        <MinhasReservasPreview />
                    </Suspense>,
                children: []
            },
        ]
    },
    {
        path: '/private/gestor',
        element: <AdminBase size="md" />,
        children: [
            {
                path: 'solicitacoesPendentes',
                element:
                    <Suspense fallback={<LoadingCircular />}>
                        <SolicitacoesPendentesPreview />
                    </Suspense>,
                children: []
            },
            {
                path: 'todasReservas',
                element:
                    <Suspense fallback={<LoadingCircular />}>
                        <TodasReservasPreview />
                    </Suspense>,
                children: []
            },
        ]
    },
]);
